<h1 mat-dialog-title>{{ 'moveSessionsToProject.title' | translate }}</h1>
<div mat-dialog-content class="modal-wide">
  <form [formGroup]="form" class="form-full-width">
    <div>
      <label class="modal-body-heading">{{ 'moveSessionsToProject.destinationProjectLabel' | translate }}</label>
      <mat-form-field appearance="outline">
        <mat-select
          [attr.test-id]="'project-dialog-project-select'"
          [placeholder]="'moveSessionsToProject.destinationProjectPlaceholder' | translate"
          formControlName="projectId"
          (selectionChange)="onProjectChange()">
          <mat-optgroup *ngFor="let group of groups$ | async" [label]="getGroupLabel(group)">
            <mat-option *ngFor="let project of group.projects" [value]="project._id">
              {{ project.label }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
        <mat-error test-id="project-dialog-projects-error">
          {{ 'moveSessionsToProject.destinationProjectRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="summary">
      <mat-icon class="mat-icon check">check_circle</mat-icon>
      <span [matTooltip]="isPreDryRun ? null : ('moveSessionsToProject.summaryTooltip' | translate)"
        [innerHTML]="'moveSessionsToProject.summaryTotal' | translate | interpolate:movableSessionIds.length:((movableSessionIds.length === 1 ? 'common.labels.session' : 'common.labels.sessions') | translate) | trusthtml">
      </span>
      <mat-icon *ngIf="!isPreDryRun">campaign</mat-icon>
      <span *ngIf="!isPreDryRun"
        [innerHTML]="'moveSessionsToProject.summaryConflicts' | translate | interpolate:conflicts.length:((conflicts.length === 1 ? 'moveSessionsToProject.conflict' : 'moveSessionsToProject.conflicts') | translate) | trusthtml">
      </span>
    </div>

    <div *ngIf="hasConflicts">
      <h1 class="mat-dialog-title">{{ 'moveSessionsToProject.conflictResolution' | translate }}</h1>
      <p>{{ 'moveSessionsToProject.conflictQuery' | translate }}</p>

      <div class="conflict-header">
        <span>{{ 'common.labels.subject' | translate }}</span>
        <span>{{ 'common.labels.session' | translate }}</span>
        <span>{{ 'common.labels.timestamp' | translate }}</span>
        <mat-form-field appearance="outline"
          [matTooltip]="'moveSessionsToProject.applyToAll' | translate"
          matTooltipPosition="above"
          class="solid-background">
          <mat-select
            placeholder="---"
            formControlName="resolveAll"
            (selectionChange)="onResolveAllChange()">
            <mat-option *ngFor="let option of conflictModeOptions" [value]="option">
              {{ 'moveSessionsToProject.allOption' | translate | interpolate:(('moveSessionsToProject.conflictMode.' + option) | translate) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngFor="let conflict of conflicts" class="conflict">
        <fw-ellipsis [text]="conflict.subjectCode" tooltipPosition="right"></fw-ellipsis>
        <span>
          <fw-ellipsis [text]="conflict.sessionLabel" tooltipPosition="right"></fw-ellipsis>
          <mat-icon *ngIf="conflict.isSessionConflict"
            [matTooltip]="'moveSessionsToProject.sessionConflictTooltip' | translate"
            matTooltipPosition="right"
            class="warning">warning</mat-icon>
        </span>
        <span>{{ conflict.timestamp }}</span>
        <mat-form-field appearance="outline" class="solid-background">
          <mat-select
            formControlName="{{ conflict.sessionId }}"
            (selectionChange)="onConflictChange()">
            <mat-option *ngFor="let option of conflictModeOptions" [value]="option">
              {{ 'moveSessionsToProject.sessionOption' | translate | interpolate:(('moveSessionsToProject.conflictMode.' + option) | translate) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <div *ngIf="hasConflicts" class="help">
    <p [innerHTML]="'moveSessionsToProject.helpTextMove' | translate | trusthtml"></p>
    <p [innerHTML]="'moveSessionsToProject.helpTextSkip' | translate | trusthtml"></p>
    <p [innerHTML]="'moveSessionsToProject.helpTextInfo' | translate | trusthtml"></p>
  </div>
  <button mat-stroked-button (click)="onCancel()" test-id="project-dialog-close">
    {{ 'common.actions.cancel' | translate }}
  </button>
  <button mat-flat-button
    color="primary"
    test-id="project-dialog-save"
    [disabled]="form.disabled || form.invalid"
    (click)="onSubmit()">
    {{ 'common.actions.continue' | translate }}
  </button>
</div>
